import { render, staticRenderFns } from "./ComponentVulnerabilities.vue?vue&type=template&id=d6915a7e&"
import script from "./ComponentVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./ComponentVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6915a7e')) {
      api.createRecord('d6915a7e', component.options)
    } else {
      api.reload('d6915a7e', component.options)
    }
    module.hot.accept("./ComponentVulnerabilities.vue?vue&type=template&id=d6915a7e&", function () {
      api.rerender('d6915a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ComponentVulnerabilities.vue"
export default component.exports